export const API_ENDPOINT = 'https://api.venturedesign.se';
export const IMAGE_URL = 'https://api.venturedesign.se';
export const PORT = 53275;
